<div class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800 space-y-3">
  <div class="text-sm">
    @if (product.linkId) {
    <p class="text-black">
      Link gerado: {{ product.linkId }}
    </p>
    }
    <div class="flex gap-4 p-4">
    <p>
      <a class="text-orange-600 hover:underline w-12 h-12 block border border-neutral-700 rounded-xl" target="_blank" [href]="getAdminLink()">
        <img src="assets/images/products/vtex.png" />
      </a>
    </p>
    @if (product.linkId) {
    <p>
      <a class="text-blue-600 hover:underline w-12 h-12 block border border-neutral-700 rounded-xl  flex justify-center items-center" target="_blank" [href]="getProductLink()">
        <img class="h-6 w-10" src="assets/images/products/fastshop.png" />
      </a>
    </p>
    }
    </div>
  </div>

  <div class="flex flex-wrap items-center gap-3">
    <h1 class="text-2xl font-bold">{{ product.name || '-' }}</h1>
  </div>

  <div class="flex flex-wrap items-center gap-3">
    <app-badge-status
      [status]="isProductActive()"
      messageTrue="Ativo"
      messageFalse="Inativo"
    ></app-badge-status>
    <app-badge-status
      [status]="isProductVisible()"
      messageTrue="Visível"
      messageFalse="Mostrar no site desativado"
    ></app-badge-status>
    @if (isMarketplaceProduct()) {
    <app-badge icon="info" type="info"> Marketplace - {{ product.marketplaceStore }} </app-badge>
    } @if (!allSkusHasImages()) {
    <app-badge icon="x" type="warning"> Há SKUs sem imagens </app-badge>
    } @if (productHasNoPrice()) {
    <app-badge icon="x" type="danger"> Produto não possui preços </app-badge>
    } @else if (productHasSkuWithNoPrices()) {
    <app-badge icon="x" type="warning"> Alguns SKUs não possuem preços </app-badge>
    } @if (!product.stores || product.stores.length === 0) {
    <app-badge icon="x" type="success"> Todas políticas comerciais </app-badge>
    }
    <app-badge-status [status]="isSpecialConditionProduct()">
      Condições especiais
    </app-badge-status>
    <app-badge-status
      [status]="product.showWithoutStock"
      messageTrue="Exibir produto sem estoque"
      messageFalse="Não exibe produto sem estoque"
    />
    @if (product.category) { @if (!product.category.isActive) {
    <app-badge icon="x" type="danger"> Categoria está inativa </app-badge>
    } @if (!product.category.activeStoreFrontLink) {
    <app-badge icon="x" type="danger"> Categoria não tem um link ativo no site </app-badge>
    } @if (!product.category.showBrandFilter) {
    <app-badge icon="x" type="danger"> Categoria não aparece no filtro de marca </app-badge>
    } @if (!product.category.showInStoreFront) {
    <app-badge icon="x" type="danger"> Categoria não aparece nos menus </app-badge>
    } } @else {
    <app-badge icon="x" type="danger"> Sem categoria </app-badge>
    }
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
    <div>
      <div>Marca</div>
      <div class="font-medium">{{ product.brandName || '-' }}</div>
    </div>
    <div>
      <div>Categoria</div>
      <div class="font-medium">{{ product.category.name || '-' }}</div>
    </div>
    <div>
      <div>ProductID</div>
      <div class="font-medium">{{ product.productId }}</div>
    </div>
    <div>
      <div>RefID</div>
      <div class="font-medium">{{ product.refId || '-' }}</div>
    </div>
    <div>
      <div>Última atualização</div>
      <div class="font-medium">{{ product.lastUpdateDate || '-' }}</div>
    </div>
    <div>
      <div>Lançamento</div>
      <div class="font-medium">{{ product.releaseDate || '-' }}</div>
    </div>
  </div>
</div>
